import { CenteredPage, PrimaryButton } from '@cmg/common';
import React from 'react';
import styled from 'styled-components';

import externalRouteFactory from '../../../common/util/externalRouteFactory';

const SHeading = styled.div`
  font-size: ${({ theme }) => theme.text.size.large};
  margin: 25px 0 40px;
`;

export const UnlockedRoute: React.FC = () => {
  return (
    <CenteredPage>
      <SHeading>Your account has been unlocked</SHeading>
      <PrimaryButton
        href={externalRouteFactory.ecmSpa.getUrl()}
        size="large"
        fullWidth
        variant="high-contrast"
      >
        Return to Login Page
      </PrimaryButton>
    </CenteredPage>
  );
};

export default UnlockedRoute;
